// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"93ed7dff","513":"b17d98b4","787":"4232b31e"}[chunkId] + ".chunk.js";
};